let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dY2UP")).then(() => parcelRequire('f9s7v'));